module.exports = __webpack_public_path__ + "static/media/Argentina.f28eaa12.svg";